import React, { useState, useEffect } from 'react';

interface CaptchaProps {
    onChange: (value: string) => void;
    currentCaptcha: string; // Nhận giá trị CAPTCHA từ props
}

const generateCaptcha = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let captcha = '';
    for (let i = 0; i < 6; i++) {
        captcha += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return captcha;
};

const Captcha: React.FC<CaptchaProps> = ({ onChange, currentCaptcha }) => {

    const [captcha, setCaptcha] = useState(currentCaptcha);

    useEffect(() => {
        setCaptcha(currentCaptcha); 
    }, [currentCaptcha]);

    const refreshCaptcha = () => {
        const newCaptcha = generateCaptcha();
        setCaptcha(newCaptcha);
        onChange("");
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    return (
        <div className="captcha-container">
            <div className="captcha-display">{captcha}</div>
            <input 
                type="text" 
                onChange={handleChange} 
                placeholder="Nhập CAPTCHA" 
                required 
                className="captcha-input"
            />
            <button type="button" onClick={refreshCaptcha} className="captcha-button">
                Làm mới
            </button>
        </div>
    );
};

export default Captcha;